var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreBenefitsThumbUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 51H6.33398C5.0079 51 3.73613 50.4732 2.79845 49.5355C1.86077 48.5979 1.33398 47.3261 1.33398 46V28.5C1.33398 27.1739 1.86077 25.9021 2.79845 24.9645C3.73613 24.0268 5.0079 23.5 6.33398 23.5H13.834M31.334 18.5V8.5C31.334 6.51088 30.5438 4.60322 29.1373 3.1967C27.7308 1.79018 25.8231 1 23.834 1L13.834 23.5V51H42.034C43.2398 51.0136 44.4099 50.591 45.3287 49.81C46.2476 49.029 46.8532 47.9423 47.034 46.75L50.484 24.25C50.5928 23.5334 50.5444 22.8017 50.3423 22.1056C50.1402 21.4096 49.7892 20.7657 49.3136 20.2188C48.838 19.6718 48.2492 19.2348 47.5879 18.938C46.9266 18.6413 46.2088 18.4918 45.484 18.5H31.334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsThumbUp);
export default __webpack_public_path__ + "static/media/core-benefits-thumb-up.f26fe68ac3cf800f1d7cb21316530e86.svg";
export { ForwardRef as ReactComponent };